import React from "react";
import { useRemoteSensors } from "@/hooks/useRemoteSensors";
import WSMSensorLocation from "@WahooFitness/wsm-native/dist/esm/types/sensor_location";
import { MenuList, MenuListItemVariant } from "@WahooFitness/redesignr";
import { t, Trans } from "@lingui/macro";
import { Box } from "@mui/system";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";

interface TirePressureConfig {
  appToken: string;
  remoteSensorId: number;
}

const TirePressureConfig = ({ appToken, remoteSensorId }: TirePressureConfig) => {
  const { remoteSensorStatus, saveRemoteSensorConfig } = useRemoteSensors(appToken);

  if (!remoteSensorStatus) {
    return null;
  }

  const remoteSensor = remoteSensorStatus?.sensors?.find(
    (sensor) => sensor?.cfg?.sensor_id === remoteSensorId
  );

  const sensorLocation = remoteSensor?.cfg?.sensor_location;
  const sensorLocationValid =
    sensorLocation &&
    [WSMSensorLocation.FRONT_WHEEL, WSMSensorLocation.REAR_WHEEL].includes(sensorLocation);

  const handleLocationChange = (
    _event: React.MouseEvent<HTMLElement>,
    newLocation: string | null
  ) => {
    if (!newLocation) return;

    const newLocationValue =
      newLocation === "Front wheel" ? WSMSensorLocation.FRONT_WHEEL : WSMSensorLocation.REAR_WHEEL;
    saveRemoteSensorConfig(remoteSensorId, { sensor_location: newLocationValue });
  };

  return (
    <MenuList
      listItems={[
        {
          id: "tire_pressure_config",
          content: t`Location`,
          hidden: !sensorLocationValid,
          variant: MenuListItemVariant.NoAction,
          secondaryContent: (
            <Box display="flex" flexDirection="column" rowGap={1} mt={1}>
              <ToggleButtonGroup
                exclusive
                fullWidth
                value={sensorLocation === 4 ? "Front wheel" : "Rear wheel"}
                onChange={handleLocationChange}
              >
                <ToggleButton value={"Front wheel"}>
                  <Trans>Front wheel</Trans>
                </ToggleButton>
                <ToggleButton value={"Rear wheel"}>
                  <Trans>Rear wheel</Trans>
                </ToggleButton>
              </ToggleButtonGroup>
            </Box>
          ),
        },
      ]}
      disableGutters
    />
  );
};

export { TirePressureConfig };
